import { ListFilters, MultiSelectOption } from '@/types';

export interface WorkScheduleFilter {
    isActive: MultiSelectOption | null;
}

export interface WorkScheduleState extends ListFilters {
    filter: WorkScheduleFilter;
}

export enum WorkScheduleMutations {
    SET_SEARCH = 'workSchedule_mutation_setSearch',
    SET_SORT = 'workSchedule_mutation_setSort',
    SET_PAGE = 'workSchedule_mutation_setPage',
    SET_FILTER = 'workSchedule_mutation_setFilter',
    CLEAR_FILTER = 'workSchedule_mutation_clearFilter',
}

export enum WorkScheduleActions {
    SET_SEARCH = 'workSchedule_action_setSearch',
    SET_SORT = 'workSchedule_action_setSort',
    SET_PAGE = 'workSchedule_action_setPage',
    SET_FILTER = 'workSchedule_action_setFilter',
    CLEAR_FILTER = 'workSchedule_action_clearFilter',
}

export enum WorkScheduleGetters {
    SEARCH = 'workSchedule_getter_search',
    SORT = 'workSchedule_getter_sort',
    PAGE = 'workSchedule_getter_page',
    DEFAULT_FILTER = 'workSchedule_getter_defaultFilter',
    FILTER = 'workSchedule_getter_filter',
    ACTIVE_FILTERS = 'workSchedule_getter_activeFilters',
}
